<template>
  <div class="app-container">
    <el-card class="mb5">
      <el-form
        ref="form"
        :model="queryForm.params"
        label-position="top"
        label-width="auto"
        size="small"
      >
        <div class="searchContainer">
          <el-row :gutter="10">
            <el-col :span="6">
              <!--CNPJ-->
              <el-form-item label="CNPJ" prop="cnpj">
                <el-input
                  v-model="queryForm.params.cnpj"
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--客户名称-->
              <el-form-item :label="$t('basicData.CustomerName')" prop="customerId">
                <!--                <el-input-->
                <!--                  v-model="queryForm.params.customerId"-->
                <!--                  :placeholder="$t('GlobalSetObj.pleaseInput')"-->
                <!--                  clearable-->
                <!--                />-->
                <QueryCustomerCmp
                  :val="queryForm.params.customerId"
                  @change="(val) => (queryForm.params.customerId = val)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--交易日期-->
              <el-form-item :label="$t('basicData.TransactionDate')">
                <el-date-picker
                  v-model="time"
                  :default-time="['00:00:00', '23:59:59']"
                  :end-placeholder="$t('GlobalSetObj.endDate')"
                  :start-placeholder="$t('GlobalSetObj.startDate')"
                  style="width: 100%"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--交易类型-->
              <el-form-item :label="$t('basicData.TransactionType')" prop="tradeType">
                <el-select
                  v-model="queryForm.params.tradeType"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in TRANSACTION_TYPE"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--交易状态-->
              <el-form-item :label="$t('basicData.TransactionStatus')" prop="status">
                <el-select
                  v-model="queryForm.params.status"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in TRANSACTION_STATUS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--流水号-->
              <el-form-item :label="$t('basicData.SerialNumber')" prop="rechargeNo">
                <el-input
                  v-model="queryForm.params.rechargeNo"
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!--资金核对状态-->
              <el-form-item :label="$t('basicData.FundStatusVerification')" prop="fundCheckStatus">
                <el-select
                  v-model="queryForm.params.fundCheckStatus"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in FUNDSTATUSVERIFICATION"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label=" ">
                <el-button
                  v-permit:remove="'btn:finance:fundManagement:customerRechargeDetails:page'"
                  icon="el-icon-search"
                  size="small"
                  type="primary"
                  @click="searchResources"
                >
                  {{ $t('operationCenter.Procurar') }}
                </el-button>
                <!--重 置-->
                <el-button icon="el-icon-refresh" size="small" @click="onReset">{{ $t('basicData.reset') }}
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-card>

    <el-card>
      <div class="feet-r mb10">
        <!-- 充值 v-permit:remove="'btn:finance:fundManagement:customerRechargeDetails:recharge'"-->
        <el-button size="small" type="primary" @click="openRecharge">{{ $t('basicData.recharge') }}
        </el-button>
        <!-- 批量充值 v-permit:remove="'btn:finance:fundManagement:customerRechargeDetails:batchRecharge'"-->
        <el-button
          class="feet-btn" size="small" type="primary"
          @click="openBatchRecharge"
        >{{ $t('basicData.BatchImportRecharge') }}
        </el-button>
        <!-- 导出 v-permit:remove="'btn:finance:fundManagement:customerRechargeDetails:export'"-->
        <el-button class="feet-btn" size="small" @click="onExport">{{ $t('receivablePayable.Export') }}
        </el-button>
      </div>

      <el-table
        :key="tableKey"
        ref="table"
        :data="tableData"
        :height="tableHeightRow.height"
        border
        class="table-height"
      >
        <!--序号-->
        <el-table-column :label="$t('basicData.serialNumber')" align="center" width="60px">
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, ind) in columns"
          :key="ind"
          :align="item.align"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <!--            附件 -->
            <div v-if="item.prop === 'receiptUrl'">
              <div
                v-for="(file, fIdx) in getReceiptFiles(scope.row.receiptUrl)"
                :key="fIdx"
                class="receipt-link"
                @click="handleDownload(file)"
              >
                {{ file.name }}
              </div>
              <span v-if="!getReceiptFiles(scope.row.receiptUrl).length">--</span>
            </div>

            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>

        <!--操作-->
        <el-table-column
          :label="$t('basicData.operate')" align="center" fixed="right"
          width="160"
        >
          <template #default="scope">
            <div v-if="!scope.row.fundCheckStatus">
              <el-popconfirm
                :title="$t('basicData.ConfirmVerification')"
                @confirm="updateStatus(scope.row, 1)"
              >
                <template slot="reference">
                  <el-button
                    v-permit:remove="
                      'btn:finance:fundManagement:customerRechargeDetails:verification'
                    "
                    size="mini"
                    type="warning"
                  >
                    {{ $t('basicData.Verification') }}
                  </el-button>
                </template>
              </el-popconfirm>

              <el-popconfirm
                :title="$t('basicData.MarkAsException')"
                @confirm="updateStatus(scope.row, 2)"
              >
                <template slot="reference">
                  <el-button
                    v-permit:remove="'btn:finance:fundManagement:customerRechargeDetails:exception'"
                    size="mini"
                    style="margin-left: 10px"
                    type="danger"
                  >
                    {{ $t('basicData.Exception') }}
                  </el-button>
                </template>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100, 500]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getCurrentPage"
          @size-change="getSizePage"
        />
      </div>
    </el-card>

    <!--    充值-->
    <el-drawer
      :before-close="handleClose"
      :title="$t('basicData.ManualRecharge')"
      :visible.sync="rechargeVisible"
      :wrapper-closable="false"
      direction="ltr"
      size="50%"
    >
      <RechargeForm :visible="rechargeVisible" @close="handleClose" />
    </el-drawer>

    <!--    批量充值-->
    <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('basicData.BatchImportRecharge')"
      :visible.sync="batchRechargeVisible"
      top="6vh"
      width="45%"
    >
      <BatchRechargeForm
        :visible="batchRechargeVisible"
        @close="handleClose"
        @submit="handleSubmit"
      />
    </el-dialog>
  </div>
</template>

<script>
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { columns, FUNDSTATUSVERIFICATION, TRANSACTION_STATUS, TRANSACTION_TYPE } from './utils';
import {
  apiFundRechargeDetail,
  apiFundRechargeDetailExport,
  apiFundRechargeDetailUpdate
} from '@/api/finance/fundManagement';
import { goFinanceExportPage } from '@/utils/goExportList';

export default {
  name: 'CustomerRechargeDetails',

  components: {
    RechargeForm: () => import('./components/RechargeForm.vue'),
    BatchRechargeForm: () => import('./components/BatchRechargeForm.vue'),
    QueryCustomerCmp: () => import('@/views/finance/cmp/Query/QueryCustomerCmp.vue')
  },

  mixins: [estimateTableHeight],

  data() {
    return {
      rechargeVisible: false,
      batchRechargeVisible: false,
      columns, // 表头
      TRANSACTION_TYPE,
      TRANSACTION_STATUS,
      FUNDSTATUSVERIFICATION,
      time: [],
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          cnpj: '',
          customerId: '', // 客户名称
          startDate: '', // 开始时间
          endDate: '', // 结束时间
          tradeType: '', // 交易类型 1:充值 2:退款
          status: '', // 交易状态  0:待确认 1:支付中 2:已支付 3:支付失败 4:已关闭
          rechargeNo: '', //  流水号
          fundCheckStatus: '' // 资金核对状态 0:待确认 1:已核收 2:异常
        }
      },

      tableData: [], // 表格数据
      total: 0,
      tableKey: new Date().getTime()
    };
  },

  created() {
    // 获取列表
    this.getContractPage();
  },
  methods: {
    // 查询
    searchResources() {
      this.queryForm.pageNumber = 1;
      this.getContractPage();
    },

    // 重置
    onReset() {
      this.$refs.form.resetFields();
      this.time = [];
      this.getContractPage();
    },

    // 翻页
    getCurrentPage(val) {
      this.queryForm.pageNumber = val;
      this.getContractPage();
    },

    // 每页显示数量变化
    getSizePage(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getContractPage();
    },

    // 请求参数
    getQueryParams() {
      const { params } = this.queryForm;
      if (this.time && this.time.length) {
        params.startDate = this.time[0];
        params.endDate = this.time[1];
      } else {
        params.startDate = '';
        params.endDate = '';
      }
      return params;
    },

    // 获取列表数据
    getContractPage() {
      apiFundRechargeDetail({
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: this.getQueryParams()
      })
        .then((res) => {
          const { code, data } = res;
          if (code === 200) {
            this.tableData = data.records || [];

            this.total = res.data.total;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // 修改单据状态
    updateStatus(row, type) {
      apiFundRechargeDetailUpdate({
        id: row.id,
        fundCheckStatus: type
      }).then((res) => {
        if (res.code === 200) {
          this.getContractPage();
        }
      });
    },

    // 人工充值
    openRecharge() {
      this.rechargeVisible = true;
    },

    // 批量充值
    openBatchRecharge() {
      this.batchRechargeVisible = true;
    },

    // 关闭充值弹窗
    handleClose() {
      this.rechargeVisible = false;
      this.batchRechargeVisible = false;
    },

    // 批量充值提交成功：关闭弹窗并刷新列表
    handleSubmit() {
      this.batchRechargeVisible = false;
      this.queryForm.pageNumber = 1;
      this.getContractPage();
    },

    // 导出
    onExport() {
      const { params } = this.queryForm;
      apiFundRechargeDetailExport(params)
        .then((res) => {
          if (res.code === 200) {
            goFinanceExportPage();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    /**
     * 解析回单附件 JSON 字符串 → 文件列表
     */
    getReceiptFiles(receiptUrlStr) {
      if (!receiptUrlStr) return [];
      let files = [];
      try {
        files = typeof receiptUrlStr === 'string' ? JSON.parse(receiptUrlStr) : receiptUrlStr;
      } catch (e) {
        files = [];
      }
      return Array.isArray(files) ? files : [];
    },

    /**
     * 下载附件
     */
    handleDownload(file) {
      if (!file || !file.url) return;
      const link = document.createElement('a');
      link.href = file.url;
      link.download = file.name || 'download';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style lang="scss" scoped>
.receipt-link {
  color: #409eff;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>
